import { render, staticRenderFns } from "./lemonMessageBox.vue?vue&type=template&id=0cc059dd&scoped=true&"
import script from "./lemonMessageBox.vue?vue&type=script&lang=js&"
export * from "./lemonMessageBox.vue?vue&type=script&lang=js&"
import style0 from "./lemonMessageBox.vue?vue&type=style&index=0&id=0cc059dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc059dd",
  null
  
)

export default component.exports